import { axiosGet } from '../ServiceBase.js';

export const getTiposCobertura = async () => {
  try {
    const tiposCobertura = await axiosGet('/v1/busquedas/tipos-coberturas');
    return tiposCobertura;
  } catch (err) {
    console.error(err);
    return null;
  }
};
